<template>
  <div></div>
</template>
<script>
  import {_studentBluetoothDetails,} from '../api/api';
  import {YearMonthDate,alertTips} from '../common/common';
  import globalData from '../common/Global';
  export default {
    data(){
      return{
        dataInfo:{},// 详情信息
        id:0,// 学生答案编号
        trackUrl:globalData.trackUrl,
      }
    },
    methods:{
      studentBluetoothDetails(){
        const self = this;
        _studentBluetoothDetails(self.id).then(res => {
          if(res.code === 0) {
            self.dataInfo = res.data
          }else{
            alertTips("error",res.message);
          }
        })
          .catch(err => {
            alertTips("error","请求失败，请刷新");
          })
      }
    },
    created(){
      this.id = this.$route.query.id;
    },
    mounted(){
      this.studentBluetoothDetails();
    }
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/StudentDetails.vue